module.exports = __webpack_public_path__ + "img/playlist-placeholder.14eaee7e.svg";